import React, {Component} from "react";
import {observer, inject} from "mobx-react";

import "../common.css";

@inject("dialog")
@observer
class Reward extends Component {
  handleClick = () => {
    this.props.dialog.setRewardOpen(true);
  };

  render() {
    return (
      <div id="nice-menu-reward" className="nice-menu-item" onClick={this.handleClick}>
        <span>
          <span className="nice-menu-flag" />
          <span className="nice-menu-name">赞赏</span>
        </span>
      </div>
    );
  }
}

export default Reward;

